module.exports = __webpack_public_path__ + "img/gal_16.2cdc6533.png";